import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-primary/5 text-primary ring-primary/15',
        success: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
        warm: 'bg-amber-50 text-amber-800 ring-amber-600/20',
        outline: 'bg-background text-foreground ring-border',
        muted: 'bg-muted text-muted-foreground ring-border',
        onDark: 'bg-white/10 text-white ring-white/20 backdrop-blur',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeVariants>;

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
